var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-tab-pane", { attrs: { name: "tax-advisor" } }, [
    _c("div", { staticClass: "row gutter-x-md justify-start" }, [
      _c("div", { staticClass: "col-md-3 col-12" }, [
        _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
          _vm._v(_vm._s(_vm.$t("tax_advisor")))
        ]),
        _c("p", { staticClass: "text-faded" }, [
          _vm._v(_vm._s(_vm.$t("tax_advisor_hint")))
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-md-9 col-12" },
        [
          _c(
            "q-field",
            { attrs: { label: _vm.$t("tax_advisor_email"), labelWidth: 3 } },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|min:1|max:255",
                    expression: "'required|min:1|max:255'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: { name: "email", placeholder: _vm.$t("email") },
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = $$v
                  },
                  expression: "email"
                }
              }),
              _c("div", { staticClass: "row items-center q-mt-xs" }, [
                _c("span", { staticClass: "text-grey-5" }, [
                  _vm._v(_vm._s(_vm.bottomText))
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "row justify-end" },
      [
        _c(
          "q-btn",
          {
            attrs: { type: "submit", color: "primary" },
            on: { click: _vm.handleSave }
          },
          [_vm._v(_vm._s(_vm.$t("save")))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }